module.exports = __webpack_public_path__ + "pc/static/img/icon33.9eb34894.png";